import React, { useReducer } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '../../../../shared/constants';
import { onTranslateBtnClick } from '../../service/translations/ugcTranslations';
import { createBiData } from '../../config/ugcTranslations';
import { ALLOCATIONS, EXPERIMENTS } from '../../../../shared/constants/experiments';
import { reducer } from './reducer';

const AppContext = React.createContext();

const AppProvider = ({ children, knownCrawler, listings, appData, requestContext }) => {
    const {
        isTouch,
        context: {
            currency,
            sessionLocale,
            userId,
            sourceComponent,
            showLMBannerInSubCPage,
            showLMBannerInSearchPage,
            wordCount
        }
    } = listings[0];
    const { rollouts = {}, flow, filter, pagination, sorting, user, assumedLanguage } = appData;
    const { categoryIds, significantLeafCategories, dominateSubCategoryId, query, currentUser } = requestContext;
    const { abTests = {} } = getContext();

    const initialState = {
        user,
        currentUser, // TODO merge with user object
        isTouch,
        currency,
        showLMBannerInSubCPage,
        showLMBannerInSearchPage,
        sourceComponent,
        assumedLanguage,
        locale: sessionLocale,
        isDefaultLocale: sessionLocale === DEFAULT_LOCALE,
        knownCrawler,
        listings,
        filter,
        pagination,
        sorting,
        wordCount,
        categoryIds,
        significantLeafCategories,
        dominateSubCategoryId,
        query,
        loading: false,
        sourceInfo: createBiData({ userId, flow }),
        showTranslatedUGC: listings[0].showTranslatedUGC,
        wasTranslatedBefore: listings[0].showTranslatedUGC,
        onTranslateBtnClick,
        rollouts,
        inUgcTranslationsRollout: rollouts.use_ugc_translations,
        searcherCrawlerBlocker: rollouts.searcher_crawler_blocker,
        isBusiness: rollouts.fiverr_business,
        inSearchServiceTiles: abTests[EXPERIMENTS.CAT_LISTINGS_SEARCH_SERVICE_TILES] === ALLOCATIONS.TEST_B,
        inWebsiteMatchBannerTest: abTests[EXPERIMENTS.CAT_LISTINGS_WEBSITE_MATCH_BANNER] === ALLOCATIONS.TEST_B,
        inServiceFiltersTest: abTests[EXPERIMENTS.CAT_LISTINGS_SERVICE_FILTERS_15_6] === ALLOCATIONS.TEST_B
    };

    const [appState, dispatch] = useReducer(reducer, initialState);

    return (
        <AppContext.Provider value={{ ...appState, dispatch }}>
            {children}
        </AppContext.Provider>
    );};

export {
    AppProvider,
    AppContext
};
